export default __webpack_public_path__ + "978185fbba684cb302d3d7f3dabaa053.svg";